/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Loading Actions 

import {
	RESOURCE_TYPE_USER_ACCOUNT,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
	RESOURCE_TYPE_USER_HISTORY_ENTRY,
	RESOURCE_TYPE_BALANCE_CHANGE_LOG,
	RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
	RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
	RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
	RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
	RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
	RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
	RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_PASSWORD,
	RESOURCE_TYPE_EXPIRED_PASSWORD,
	RESOURCE_TYPE_PASSWORD_RESET,
	RESOURCE_TYPE_DEPOSIT,
	RESOURCE_TYPE_DEPOSIT_INVITE,
	RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_INTEREST,
	RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
	RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_USER_STATS,
	RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
	RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
	RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
	RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
	RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
	RESOURCE_TYPE_DEPOSIT_GROUP,
	RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_USER_GROUP,
	RESOURCE_TYPE_PROPERTY_GROUP,
	RESOURCE_TYPE_PROPERTY_USER_GROUP,
	RESOURCE_TYPE_DISPUTE,
	RESOURCE_TYPE_DISPUTE_SPLIT,
	RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
	RESOURCE_TYPE_PROPERTY,
	RESOURCE_TYPE_PROPERTY_ADDRESS,
	RESOURCE_TYPE_COMPLIANCE,
	RESOURCE_TYPE_COMPLIANCE_RULE,
	RESOURCE_TYPE_COMPLIANCE_HISTORY,
	RESOURCE_TYPE_EMAIL_TEMPLATE,
	RESOURCE_TYPE_EMAIL_VERIFICATION,
	RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
	RESOURCE_TYPE_EMAIL_EVENT,
	RESOURCE_TYPE_SENT_EMAIL,
	RESOURCE_TYPE_MAILBOX,
	RESOURCE_TYPE_MAILBOX_META_DATA,
	RESOURCE_TYPE_MAILBOX_MESSAGE,
	RESOURCE_TYPE_PERMISSION_ENTRY,
	RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
	RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
	RESOURCE_TYPE_RESOURCE_PERMISSIONS,
	RESOURCE_TYPE_ORGANIZATION,
	RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
	RESOURCE_TYPE_INVOICE,
	RESOURCE_TYPE_INVOICE_ITEM,
	RESOURCE_TYPE_PAYMENT_REQUEST,
	RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
	RESOURCE_TYPE_USER_WITHDRAW,
	RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
	RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
	RESOURCE_TYPE_LOAN_APPLICATION,
	RESOURCE_TYPE_LOAN_SYSTEM_INFO,
	RESOURCE_TYPE_LOAN,
	RESOURCE_TYPE_LOAN_HISTORY,
	RESOURCE_TYPE_LOAN_PAYMENT_LOG,
	RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
	RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
	RESOURCE_TYPE_SEZZLE_ORDER,
	RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
	RESOURCE_TYPE_BANK_ACCOUNT,
	RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
	RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
	RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
	RESOURCE_TYPE_BANK_TRANSFER,
	RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
	RESOURCE_TYPE_FUNDS_LOCK,
	RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
	RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
	RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
	RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
	RESOURCE_TYPE_EVENT,
	RESOURCE_TYPE_EVENT_HOOK,
	RESOURCE_TYPE_NOTIFICATION,
	RESOURCE_TYPE_ACTION_ITEM,
	RESOURCE_TYPE_UPDATE_LOG_ENTRY,
	RESOURCE_TYPE_STORAGE_FILE,
	RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
	RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
	RESOURCE_TYPE_SNAPSHOT,
	RESOURCE_TYPE_IP_ADDRESS,
	RESOURCE_TYPE_KNOWN_IP_ADDRESS,
	RESOURCE_TYPE_USER_AGENT,
	RESOURCE_TYPE_KNOWN_USER_AGENT,
	RESOURCE_TYPE_SYSTEM_STATS,
	RESOURCE_TYPE_RESOURCE_NOTE,
	RESOURCE_TYPE_DEPOSIFY_TAG,
	RESOURCE_TYPE_PERMANENT_LINK,
	RESOURCE_TYPE_ONLINE_USER,
	RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
	RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
	RESOURCE_TYPE_YARDI_VOYAGER_PET,
	RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
	RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
	RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
	RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS
} from "../constants/resourceTypeConstants";
import {loadingActionLoadResourceFromServer} from "../../clientShared/actions/sharedLoadingActions";
import {resourceActionUpdateSingleResource} from "../../clientShared/actions/resourceActions";

export function loadingActionLoadUserAccountFromServer(account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_USER_ACCOUNT,
			account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadUserAccountBalanceFromServer(account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
			account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadUserAccountBalanceSourceFromServer(source_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
			source_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadUserHistoryEntryFromServer(entry_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_USER_HISTORY_ENTRY,
			entry_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadBalanceChangeLogFromServer(change_log_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_BALANCE_CHANGE_LOG,
			change_log_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadInternationalUserBankAccountFromServer(bank_account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
			bank_account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadUSDomesticUserBankAccountFromServer(bank_account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
			bank_account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadUserBankAccountDeltaFromServer(delta_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
			delta_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadUserAccountSettingsFromServer(account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
			account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadAdminGhostUserAccountFromServer(ghost_account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
			ghost_account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadUserAccountFinalizationFromServer(account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
			account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadThirdPartyUserAccountMappingFromServer(account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
			account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPreviousEmailAddressFromServer(previous_email_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
			previous_email_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPendingEmailChangeFromServer(change_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
			change_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadArchivedPendingEmailChangeFromServer(change_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
			change_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPasswordFromServer(account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PASSWORD,
			account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadExpiredPasswordFromServer(expired_password_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_EXPIRED_PASSWORD,
			expired_password_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPasswordResetFromServer(reset_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PASSWORD_RESET,
			reset_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositFromServer(deposit_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT,
			deposit_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositInviteFromServer(deposit_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_INVITE,
			deposit_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositAdjustmentFromServer(adjustment_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
			adjustment_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositInterestFromServer(interest_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_INTEREST,
			interest_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositHistoryEntryFromServer(entry_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
			entry_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositCloseRequestFromServer(deposit_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
			deposit_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositUserStatsFromServer(account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_USER_STATS,
			account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositBankMappingFromServer(map_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
			map_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositBulkImportFromServer(bulk_import_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
			bulk_import_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositInterestLogFromServer(entry_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
			entry_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadArchivedDepositCloseRequestFromServer(archive_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
			archive_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositWithheldFundsFromServer(withheld_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
			withheld_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPMCReportTimetableFromServer(timetable_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
			timetable_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositGroupFromServer(group_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_GROUP,
			group_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositPostCloseAdjustmentFromServer(adjustment_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
			adjustment_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDepositUserGroupFromServer(deposit_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIT_USER_GROUP,
			deposit_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPropertyGroupFromServer(group_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PROPERTY_GROUP,
			group_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPropertyUserGroupFromServer(property_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PROPERTY_USER_GROUP,
			property_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDisputeFromServer(dispute_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DISPUTE,
			dispute_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDisputeSplitFromServer(split_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DISPUTE_SPLIT,
			split_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDisputeInterventionRequestFromServer(request_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
			request_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPropertyFromServer(property_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PROPERTY,
			property_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPropertyAddressFromServer(property_address_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PROPERTY_ADDRESS,
			property_address_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadComplianceFromServer(compliance_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_COMPLIANCE,
			compliance_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadComplianceRuleFromServer(compliance_rule_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_COMPLIANCE_RULE,
			compliance_rule_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadComplianceHistoryFromServer(compliance_history_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_COMPLIANCE_HISTORY,
			compliance_history_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadEmailTemplateFromServer(template_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_EMAIL_TEMPLATE,
			template_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadEmailVerificationFromServer(verification_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_EMAIL_VERIFICATION,
			verification_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadEmailVerificationRecordFromServer(verification_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
			verification_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadEmailEventFromServer(event_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_EMAIL_EVENT,
			event_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadSentEmailFromServer(email_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_SENT_EMAIL,
			email_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadMailboxFromServer(mailbox_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_MAILBOX,
			mailbox_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadMailboxMetaDataFromServer(meta_data_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_MAILBOX_META_DATA,
			meta_data_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadMailboxMessageFromServer(message_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_MAILBOX_MESSAGE,
			message_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPermissionEntryFromServer(permission_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PERMISSION_ENTRY,
			permission_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPermissionLogEntryFromServer(log_entry_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
			log_entry_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPermissionsOrganizationSettingsFromServer(organization_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
			organization_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadResourcePermissionFromServer(permission_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_RESOURCE_PERMISSIONS,
			permission_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadOrganizationFromServer(organization_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_ORGANIZATION,
			organization_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadOrganizationResourcePermissionRuleFromServer(rule_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
			rule_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadInvoiceFromServer(invoice_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_INVOICE,
			invoice_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadInvoiceItemFromServer(invoice_item_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_INVOICE_ITEM,
			invoice_item_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPaymentRequestFromServer(request_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PAYMENT_REQUEST,
			request_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadStripePaymentLogFromServer(payment_log_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
			payment_log_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadUserWithdrawFromServer(withdraw_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_USER_WITHDRAW,
			withdraw_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPriorityACHPaymentFromServer(payment_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
			payment_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPriorityACHRecurringPaymentFromServer(recurring_payment_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
			recurring_payment_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadLoanApplicationFromServer(application_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_LOAN_APPLICATION,
			application_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadLoanSystemInfoFromServer(loan_info_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_LOAN_SYSTEM_INFO,
			loan_info_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadLoanFromServer(loan_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_LOAN,
			loan_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadLoanHistoryFromServer(loan_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_LOAN_HISTORY,
			loan_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadLoanPaymentLogFromServer(log_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_LOAN_PAYMENT_LOG,
			log_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadStripeWebhookLogFromServer(log_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
			log_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadUserAccountPaymentProviderInfoFromServer(account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
			account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadSezzleOrderFromServer(sezzle_order_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_SEZZLE_ORDER,
			sezzle_order_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadSezzleWebhookEventFromServer(event_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
			event_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadBankAccountFromServer(bank_account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_BANK_ACCOUNT,
			bank_account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadBankAccountHistoricalInterestRateFromServer(rate_history_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
			rate_history_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadBankAccountInterestFromServer(interest_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
			interest_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadBankAccountBalanceRecordFromServer(record_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
			record_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadBankTransferFromServer(transfer_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_BANK_TRANSFER,
			transfer_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadBulkFundsTransferFromServer(bulk_transfer_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
			bulk_transfer_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadFundsLockFromServer(lock_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_FUNDS_LOCK,
			lock_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadFundsLockReleaseLogFromServer(release_log_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
			release_log_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadReleasedFundsLockFromServer(lock_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
			lock_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadBalanceSourceTransferFromServer(transfer_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
			transfer_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadCreditUserAccountLogFromServer(credit_log_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
			credit_log_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadEventFromServer(event_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_EVENT,
			event_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadEventHookFromServer(hook_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_EVENT_HOOK,
			hook_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadNotificationFromServer(notification_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_NOTIFICATION,
			notification_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadActionItemFromServer(item_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_ACTION_ITEM,
			item_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadUpdateLogFromServer(entry_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_UPDATE_LOG_ENTRY,
			entry_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadStorageFileFromServer(file_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_STORAGE_FILE,
			file_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadAttachedStorageFilesFromServer(attached_files_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
			attached_files_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadSystemHistoryEntryFromServer(entry_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
			entry_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadSnapshotFromServer(snapshot_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_SNAPSHOT,
			snapshot_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadIPAddressFromServer(ip_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_IP_ADDRESS,
			ip_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadKnownIPAddressFromServer(known_ip_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_KNOWN_IP_ADDRESS,
			known_ip_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadUserAgentFromServer(user_agent_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_USER_AGENT,
			user_agent_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadKnownUserAgentFromServer(known_user_agent_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_KNOWN_USER_AGENT,
			known_user_agent_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadSystemStatsFromServer(stats_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_SYSTEM_STATS,
			stats_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadResourceNoteFromServer(notes_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_RESOURCE_NOTE,
			notes_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadDeposifyTagFromServer(tag_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_DEPOSIFY_TAG,
			tag_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadPermanentLinkFromServer(link_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_PERMANENT_LINK,
			link_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadOnlineUserFromServer(online_user_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_ONLINE_USER,
			online_user_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadFrontendGeneralSettingsFromServer(settings_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
			settings_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiScreeningWorksProXMLFromServer(xml_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
			xml_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerXMLFromServer(voyager_xml_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_XML,
			voyager_xml_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerTransactionFromServer(voyager_transaction_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
			voyager_transaction_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerResidentFromServer(voyager_resident_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
			voyager_resident_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerResidentCustomColumnFromServer(custom_column_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
			custom_column_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerPropertyUnitFromServer(voyager_property_unit_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
			voyager_property_unit_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerPropertyFromServer(voyager_property_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
			voyager_property_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerPMCServiceInterfaceVersionFromServer(service_interface_version_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
			service_interface_version_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerPMCFromServer(deposify_pmc_account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_PMC,
			deposify_pmc_account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerPMCCredentialsFromServer(deposify_pmc_account_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
			deposify_pmc_account_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerPetFromServer(pet_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_PET,
			pet_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerILSGuestCardEventFromServer(guest_card_event_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
			guest_card_event_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerChargeFromServer(voyager_charge_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
			voyager_charge_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerChargeCodeFromServer(charge_code_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
			charge_code_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerDepositCreateIntentFromServer(create_intent_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
			create_intent_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerDepositCloseIntentFromServer(close_intent_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
			close_intent_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerDepositWithholdIntentFromServer(withhold_intent_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
			withhold_intent_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerEventFromServer(event_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
			event_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerFlexDepositIntentFromServer(flex_intent_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
			flex_intent_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerPhoneFromServer(phone_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
			phone_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerOtherOccupantFromServer(other_occupant_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
			other_occupant_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerPMCCustomColumnSettingsFromServer(column_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
			column_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerPMCStatsFromServer(stats_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
			stats_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerPMCStatsCollectorFromServer(stats_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
			stats_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerActiveScanLogEntryFromServer(log_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
			log_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
export function loadingActionLoadYardiVoyagerSystemSettingsFromServer(settings_uid) {
	return dispatch => {
		return dispatch(loadingActionLoadResourceFromServer(RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS,
			settings_uid,
			resourceActionUpdateSingleResource,
		));
	}
}
